import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";

/**
 * Bus Station Service
 * Otobüs terminalleri (busstation) ile ilgili API servisleri
 */
export const busStationService = {
  /**
   * Otobüs terminalleri listesini getir
   * @param {Object} payload - API payload
   * @param {string} payload.LocationFirstLetter - İlk harf filtresi (örn: "A", boş string tümü)
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   */
  getStationList: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.station.getStationList,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Terminal tag bilgilerini getir
   * @param {Object} payload - { Slug, LanguageCode }
   */
  getStationTag: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.station.getStationTag,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Terminal için popüler rotaları getir
   * @param {Object} payload - { Slug, CurrencyCode, LanguageCode }
   */
  getStationPopularRoutes: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.station.getStationPopularRoutes,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Terminal hakkında içeriklerini getir
   * @param {Object} payload - { Slug, LanguageCode }
   */
  getStationAbout: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.station.getStationAbout,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Terminalde hizmet veren firmaları getir
   * @param {Object} payload - { Slug, LanguageCode }
   */
  getStationCompanies: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.station.getStationCompanies,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Terminale nasıl gidileceğini anlatan içeriği getir
   * @param {Object} payload - { Slug, LanguageCode }
   */
  getStationHowToReach: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.station.getStationHowToReach,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Terminal koordinat bilgilerini getir
   * @param {Object} payload - { Slug, LanguageCode }
   */
  getStationCoordinates: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.station.getStationCoordinates,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Yakındaki terminalleri getir
   * @param {Object} payload - { Slug, LanguageCode }
   */
  getNearbyStations: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.station.getNearbyStations,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Terminal için diğer fırsatları getir
   * @param {Object} payload - { Slug, CurrencyCode, LanguageCode }
   */
  getOtherOpportunities: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.station.getOtherOpportunities,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Terminal SSS (FAQ) içeriklerini getir
   * @param {Object} payload - { Slug, LanguageCode }
   */
  getStationFaq: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.station.getStationFaq,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Terminal embed harita bilgisini getir
   * @param {Object} payload - { Slug, LanguageCode }
   */
  getStationEmbedMap: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.station.getStationEmbedMap,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Terminal listesi hakkında içeriklerini getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Payload Example:
   * {
   *   "LanguageCode": "tr"
   * }
   */
  getStationListAbout: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.station.getStationListAbout,
      payload,
      headers,
      hasErrorHandler,
    }),
};

export default busStationService;


